import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import AccountContent from "../../components/Account/AccountContent";
import { useDispatch, useSelector } from "react-redux";
import { getAccountDetailsList } from "../../redux/actions/accountAction";
const Account = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user?.userData);

  useEffect(() => {
    dispatch(
      getAccountDetailsList({
        id: userData?.id,
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Account" title="Account">
        <Box className="globalContainer_For_Content">
          <AccountContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Account;
